const routes = [
  { path: '/', name: 'Home', redirect: '/index' },
  { path: '/index', name: 'Main', component: () => import('../view/MainPage') },
  { path: '/login', name: 'Login', component: () => import('../view/LoginPage') }
]

export default routes
